import {
  FETCH_BATCH_PROCESSES_REQUEST,
  FETCH_BATCH_PROCESSES_SUCCESS,
  FETCH_BATCH_PROCESSES_FAILURE,
  DELETE_BATCH_PROCESS_REQUEST,
  DELETE_BATCH_PROCESS_SUCCESS,
  DELETE_BATCH_PROCESS_FAILURE,
} from '../../types/batchInventoryProcess/batchInventoryProcessTypes';
import { getBatchProcesses, deleteBatchProcess as deleteBatchProcessApi } from '../../../api/batchInventoryProcess/batchInventoryProcessApi';
import { toast } from 'react-toastify';

export const fetchBatchProcesses = (params = {}, options = {}) => async (dispatch) => {
  const append = Boolean(options.append);
  dispatch({ type: FETCH_BATCH_PROCESSES_REQUEST, append });
  try {
    const response = await getBatchProcesses(params);
    dispatch({ type: FETCH_BATCH_PROCESSES_SUCCESS, payload: response.data, append });
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch batch processes';
    dispatch({ type: FETCH_BATCH_PROCESSES_FAILURE, payload: errorMessage, append });
    toast.error('Failed to fetch batch processes.');
    throw error;
  }
};

export const deleteBatchProcess = (id) => async (dispatch) => {
  dispatch({ type: DELETE_BATCH_PROCESS_REQUEST });
  try {
    await deleteBatchProcessApi(id);
    dispatch({ type: DELETE_BATCH_PROCESS_SUCCESS, payload: id });
    toast.success('Process deleted successfully.');
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete process';
    dispatch({ type: DELETE_BATCH_PROCESS_FAILURE, payload: errorMessage });
    toast.error('Failed to delete process.');
  }
}; 